import { render, staticRenderFns } from "./ForeignBoxOfficeList.vue?vue&type=template&id=3f663102&scoped=true"
import script from "./ForeignBoxOfficeList.vue?vue&type=script&lang=js"
export * from "./ForeignBoxOfficeList.vue?vue&type=script&lang=js"
import style0 from "./ForeignBoxOfficeList.vue?vue&type=style&index=0&id=3f663102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f663102",
  null
  
)

export default component.exports